import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faBars,
  faBriefcase,
  faCalendar,
  faCalendarAlt,
  faCheck,
  faGift,
  faCheckCircle,
  faCheckSquare,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCloud,
  faClock,
  faColumns,
  faDownload,
  faEdit,
  faEuroSign,
  faExclamationCircle,
  faEnvelope,
  faFemale,
  faFileContract,
  faFilter,
  faHome,
  faLink,
  faLongArrowAltDown,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faMale,
  faMinus,
  faMinusCircle,
  faMoneyCheck,
  faPen,
  faPhone,
  faPowerOff,
  faPlus,
  faPlusCircle,
  faQuestionCircle,
  faRedo,
  faSearch,
  faTag,
  faThumbsUp,
  faTimes,
  faTrash,
  faUpload,
  faUser,
  faUserCircle,
  faHistory,
  faBook,
  faTimesCircle,
  faEllipsisH,
} from '@fortawesome/free-solid-svg-icons';

import {
  faCircle as faRegularCircle,
  faDotCircle as faRegularDotCircle,
  faEye as faRegularEye,
  faEyeSlash as faRegularEyeSlash,
  faMinusSquare,
  faPlusSquare,
  faQuestionCircle as faQuestionRegularCircle,
  faSquare,
} from '@fortawesome/free-regular-svg-icons';
import {
  faFacebookMessenger,
} from '@fortawesome/free-brands-svg-icons';

library.add(
  [
    // Solid
    faBars,
    faBook,
    faBriefcase,
    faCalendar,
    faCalendarAlt,
    faCheck,
    faCheckCircle,
    faCheckSquare,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCloud,
    faClock,
    faColumns,
    faDownload,
    faEdit,
    faEnvelope,
    faEuroSign,
    faExclamationCircle,
    faEllipsisH,
    faFilter,
    faHome,
    faFemale,
    faFileContract,
    faGift,
    faLink,
    faLongArrowAltDown,
    faLongArrowAltLeft,
    faLongArrowAltRight,
    faMinus,
    faMale,
    faMinusCircle,
    faMoneyCheck,
    faPen,
    faPhone,
    faPowerOff,
    faPlus,
    faPlusCircle,
    faQuestionCircle,
    faRedo,
    faSearch,
    faTag,
    faThumbsUp,
    faTimes,
    faTimesCircle,
    faTrash,
    faUpload,
    faUser,
    faUserCircle,
    faHistory,

    // Regular
    faMinusSquare,
    faPlusSquare,
    faQuestionRegularCircle,
    faRegularCircle,
    faRegularDotCircle,
    faRegularEye,
    faRegularEyeSlash,
    faSquare,

    // Brand
    faFacebookMessenger,
  ],
);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
